var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "11px",
    viewBox: "0 0 14 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "enter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-task-states",
    transform: "translate(-1134.000000, -457.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(714.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy-5",
    transform: "translate(109.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card/Task-Copy-5-+-Card/Task-Copy-9-+-Card/Task-Copy-10-+-Card/Task-Copy-11-+-Card/Task-Copy-6-+-Card/Task-Copy-7-+-Card/Task-Copy-8-Mask",
    transform: "translate(16.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "enter",
    transform: "translate(294.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0625,5.36133333 L14.0625,2.69466667 C14.0625,2.53733333 14.0026667,2.40533333 13.883,2.29866667 C13.7633333,2.192 13.6175,2.13881481 13.4455,2.13910988 C13.2735,2.13940741 13.125,2.19259259 13,2.29866667 C12.875,2.40474074 12.8125,2.53674074 12.8125,2.69466667 L12.8125,5.36133333 C12.8125,6.21318519 12.474,6.94 11.797,7.54177778 C11.12,8.14355556 10.3023333,8.44444444 9.344,8.44444444 L4.0315,8.44444444 L5.797,6.88888889 C5.91166667,6.77777778 5.969,6.64577778 5.969,6.49288889 C5.969,6.34 5.90916667,6.21037037 5.7895,6.104 C5.66983333,5.99762963 5.524,5.94444444 5.352,5.94444444 C5.18,5.94444444 5.0315,6 4.9065,6.11111111 L2.125,8.58355556 C2,8.69466667 1.9375,8.82666667 1.9375,8.97955556 C1.9375,9.13244444 2,9.26444444 2.125,9.37555556 L4.9845,11.9173333 C5.1095,12.0284444 5.258,12.084 5.43,12.084 C5.602,12.084 5.7505,12.0308148 5.8755,11.9244444 C6.0005,11.8180741 6.063,11.6884444 6.063,11.5355556 C6.063,11.3826667 6.0005,11.2506667 5.8755,11.1395556 L4.094,9.556 L9.344,9.556 C10.646,9.556 11.758,9.14622222 12.68,8.32666667 C13.602,7.50711111 14.063,6.51866667 14.063,5.36133333 L14.0625,5.36133333 Z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.c8a23b2d.svg";
export { ForwardRef as ReactComponent };